import { makeUclComponent } from '@rbilabs/universal-components';

import { ActionsheetContent } from 'components/action-sheet';

export const ActionsheetContentStyled = makeUclComponent(ActionsheetContent).withConfig({
  maxHeight: '100%',
  alignItems: 'stretch',
});
